// extracted by mini-css-extract-plugin
export default {"partner-page":"info-link_partner-page__N+Wyr","wrapper":"info-link_wrapper__ZQ+B3","title":"info-link_title__nI3Kn","text":"info-link_text__Gejb9"};